/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import type { AxisScale } from '@visx/axis';
import { LinePath as LinePathCore } from '@visx/shape';
import type { LinePathProps as LinePathCoreProps } from '@visx/shape/lib/shapes/LinePath';
import { Children, cloneElement, createContext, type ForwardedRef, forwardRef, isValidElement, type ReactNode } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';
import { CircleGlyphs, type CircleGlyphsProps } from '../circle-glyphs/circle-glyphs.component';

type LinePathProps<Datum> = Omit<
  LinePathCoreProps<Datum>,
  'className' | 'style' | 'data' | 'x' | 'y' | 'children' | 'defined'
> & {
  style?: stylex.StyleXStyles;
  data?: { x: number; y: number }[];
  xScale?: AxisScale;
  yScale?: AxisScale;
  color?: string;
  size?: number;
  innerWidth?: number;
  innerHeight?: number;
  children?: ReactNode;
};

const LinePathContext = createContext<ContextValue<LinePathProps<object>, SVGPathElement>>({});

const LinePath = forwardRef((props: LinePathProps<object>, ref: ForwardedRef<SVGPathElement>) => {
  [props, ref] = useContextProps(props, ref, LinePathContext);

  const {
    style,
    data = [],
    xScale,
    yScale,
    color = 'transparent',
    size = 1,
    children,
    innerWidth,
    innerHeight,
    ...coreProps
  } = props;

  return (
    <>
      <LinePathCore
        innerRef={ref}
        data={data}
        x={(datum) => Number(xScale?.(datum.x) ?? 0)}
        y={(datum) => Number(yScale?.(datum.y) ?? 0)}
        stroke={color}
        strokeWidth={size}
        fill="none"
        {...stylex.props(styles.base, style)}
        {...coreProps}
      />
      {Children.map(children, (child) => {
        if (!isValidElement<CircleGlyphsProps>(child) || child.type !== CircleGlyphs) {
          return child;
        }

        return cloneElement(child, {
          data: child.props.data ?? data,
          xScale: child.props.xScale ?? xScale,
          yScale: child.props.yScale ?? yScale,
          color: child.props.color ?? color,
          innerWidth,
          innerHeight,
          size: child.props.size ?? size * 6,
          strokeWidth: child.props.strokeWidth ?? Math.max(size / 1.5, 1),
        });
      })}
    </>
  );
});

const styles = stylex.create({
  base: {
    vectorEffect: 'non-scaling-stroke',
  },
});

export { LinePath, LinePathContext, type LinePathProps };
